// Policy acknowledgment forms. The policy wording is the legacy PL Hub text
// (translation.json employeeForms.policies), rendered by SimplePolicyForm.
import React from 'react';
import SimplePolicyForm from './SimplePolicyForm';

// Form #4: Non-Disclosure & Conflict of Interest
export const InterestConflictPolicyForm = (props) => (
  <SimplePolicyForm {...props} policyKey="interestConflict" />
);

// Form #6: Human Resources Policy
export const HumanResourcesPolicyForm = (props) => (
  <SimplePolicyForm {...props} policyKey="humanResources" />
);

// Form #7: Discipline Policy
export const DisciplinePolicyForm = (props) => (
  <SimplePolicyForm {...props} policyKey="discipline" />
);

// Form #10: Violence in Workplace Prevention
export const ViolencePreventionPolicyForm = (props) => (
  <SimplePolicyForm {...props} policyKey="violencePrevention" />
);

// Form #12: Health and Safety Policy
export const HealthSafetyPolicyForm = (props) => (
  <SimplePolicyForm {...props} policyKey="healthSafety" />
);

// Form #13: Vehicle + Mobile Equipment Policy
export const EquipmentPolicyForm = (props) => (
  <SimplePolicyForm {...props} policyKey="equipment" />
);

// Form #14: Employment Standards Act
export const EmploymentStandardsActForm = (props) => (
  <SimplePolicyForm {...props} policyKey="employmentStandards" />
);

// Form #16: Telephone and Electronic Device Policy
export const ElectronicDevicePolicyForm = (props) => (
  <SimplePolicyForm {...props} policyKey="electronicDevice" />
);
